module.exports = __webpack_public_path__ + "img/930.b7d6e0e8.png";